import React from 'react'
import { Grid } from 'semantic-ui-react'

export const ContainerLayout: React.FC<{}> = ({ children }) => (
  <Grid container>
    <Grid.Row>
      <Grid.Column>{children}</Grid.Column>
    </Grid.Row>
  </Grid>
)
